// Generate a random array with specified parameters
export const generateRandomArray = (size, min, max) => {
  const array = [];
  for (let i = 0; i < size; i++) {
    array.push(Math.floor(Math.random() * (max - min + 1)) + min);
  }
  return array;
};

// Check if an array is sorted
export const isArraySorted = (array) => {
  for (let i = 1; i < array.length; i++) {
    if (array[i] < array[i - 1]) {
      return false;
    }
  }
  return true;
};

// Shuffle an array (Fisher-Yates algorithm)
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Create a nearly sorted array
export const createNearlySortedArray = (size, min, max, swapCount = 5) => {
  const array = [];
  for (let i = 0; i < size; i++) {
    array.push(min + Math.floor((i / (size - 1)) * (max - min)));
  }
  
  // Make some random swaps to create a nearly sorted array
  for (let i = 0; i < swapCount; i++) {
    const idx1 = Math.floor(Math.random() * size);
    const idx2 = Math.floor(Math.random() * size);
    [array[idx1], array[idx2]] = [array[idx2], array[idx1]];
  }
  
  return array;
};

// Create a reversed array
export const createReversedArray = (size, min, max) => {
  const array = [];
  for (let i = 0; i < size; i++) {
    array.push(max - Math.floor((i / (size - 1)) * (max - min)));
  }
  return array;
};
